<script lang="ts">
  import { appStore } from "$app/store.svelte"
  import { xhr } from "$app/utils"

  interface Props {
    goal: GoalType
    onduplicated: (goal: GoalType) => void
  }

  let { goal, onduplicated }: Props = $props()

  let goalTasks: TaskType[] = $state([])

  goalTasks = appStore.tasks.filter((t) => t.goal_id === goal.id)

  let selectedTasks = $derived(goalTasks.filter((t) => t._selected))

  const dates = appStore.dates
  const meeting_type = appStore.meeting_type
  const channel_id = appStore.channel_id

  let form = $state({
    id: goal.id,
    name: goal.name,
    parent_goal_id: null
  })

  if (meeting_type === "quarterly") {
    form.parent_goal_id = goal.parent_goal_id
  }
  let saving = $state(false)

  let errors: any = $state({})

  function unselectGoal(): void {
    const idx = appStore.goals.findIndex((g) => g.id === goal.id)
    appStore.goals[idx]._selected = false
    const tsk = goalTasks.forEach((t) => (t._selected = false))
  }

  const year: string = dates.next_date_end.split("-")[0]
  const annualGoals = appStore.goals.filter((g) => {
    const d =
      typeof g.expected_at === "string"
        ? g.expected_at
        : JSON.stringify(g.expected_at)
    return g.type === "AnnualGoal" && d.slice(0, 4) === year
  })

  async function duplicateGoal(): Promise<void> {
    if (form.name === "") {
      errors.name = "Goal name is required"
      return
    }
    if (form.parent_goal_id === "") {
      errors.parent_goal_id = "Parent goal is required"
      return
    }
    if (annualGoals.find((g) => g.id === form.parent_goal_id) === undefined) {
      errors.parent_goal_id = "Select an annual goal from the list"
      return
    }
    saving = true
    try {
      const resp = await xhr.post<GoalType>(
        `/plans/${goal.plan_id}/quarterly_goals/duplicate?channel=${channel_id}`,
        {
          id: form.id,
          goal: {
            name: form.name,
            status: "on_track",
            expected_at: dates.next_date_end,
            task_ids: selectedTasks.map((t) => t.id),
            parent_goal_id: form.parent_goal_id
          }
        }
      )
      unselectGoal()
      onduplicated(resp.data)
    } catch (e: any) {
      errors = e.response.data.errors
      console.error(e.response)
    } finally {
      saving = false
    }
  }

  function selectTasks(): void {
    goalTasks.forEach((t) => (t._selected = true))
    appStore.tasks = appStore.tasks
  }
</script>

<div data-name="quarterly-duplicate">
  <h2 class="text-gray-500 text-xl">
    Duplicate goal to
    <span class="font-semibold">{dates.next_quarter}</span>
  </h2>

  <div class="input-cont py-2">
    <label for="goal_name">Goal name</label>
    <input
      type="text"
      id="goal_name"
      class="input w-full"
      bind:value={form.name}
    />
    <div class="text-red-500 text-sm py-1">
      {errors?.name || ""}
    </div>
  </div>

  <div class="input-cont py-2">
    <label for="parent_goal_id">Parent goal</label>
    <select
      bind:value={form.parent_goal_id}
      data-name="goal-select-parent-goal"
      id="parent_goal_id"
    >
      {#each annualGoals as ag (ag.id)}
        <option value={ag.id}>{ag.name}</option>
      {/each}
    </select>
    <div class="text-red-500 text-sm py-1">
      {errors?.parent_goal_id || ""}
    </div>
  </div>

  {#if goalTasks.length > 0}
    <div class="text-center py-2 text-gray-500" data-name="message">
      Selected {selectedTasks.length} tasks of {goalTasks.length}.
      {#if selectedTasks.length !== goalTasks.length}
        <button
          class="text-blue-500 text-sm"
          type="button"
          onclick={() => selectTasks()}
        >
          Select all sub tasks
        </button>
      {/if}
    </div>
  {/if}

  <div class="text-center mt-4">
    <button
      onclick={duplicateGoal}
      disabled={saving}
      class="btn btn-rounded success btn-big"
      data-name="duplicate-goal-button"
    >
      Duplicate Goal
    </button>
  </div>
</div>
